import { trackAnalyticsError } from './trackAnalyticsError.js';

export const safeBuildEventObj = (buildAnalyticsFn, ...args) => {
    try {
        return buildAnalyticsFn(...args);
    } catch (e) {
        trackAnalyticsError(e);
    }
};
